import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ProjectStreamService } from 'src/app/shared/common/current-project/project-stream.service';
import { environment } from 'src/environments/environment';

export interface FieldConfigTag {
    label: string;
    description: string;
    projectId: string;
    color: string;
}

@Injectable({
    providedIn: 'root'
})
export class FieldConfigService {
    constructor(private http: HttpClient, private projectStream: ProjectStreamService) {}

    private get baseUrl(): string {
        return environment.fieldConfigUrl;
    }

    public getProjectTags(projectId: string): Promise<FieldConfigTag[]> {
        const projectTrn = this.projectStream.toProjectTrn(projectId);
        const path = `${this.baseUrl}/projects/${projectTrn}/tags`;
        return lastValueFrom(this.http.get<FieldConfigTag[]>(path));
    }
}
